import * as joint from '@clientio/rappid';

import { BaseLinkVerticeCalculator } from './BaseLinkVerticeCalculator';
import { VerticeCalculatorInput } from './link-adjust-types';

export class LinkVerticeCalculator extends BaseLinkVerticeCalculator {
  constructor() {
    super();
  }

  setFirstHorizontalVertices(
    input: VerticeCalculatorInput,
    newVertices: joint.dia.Point[],
    mouseEvent: MouseEvent,
    verticeIndex: number,
  ): void {
    return super.setFirstHorizontalVertices(input, newVertices, mouseEvent, verticeIndex);
  }

  setFirstVerticalVertices(
    input: VerticeCalculatorInput,
    newVertices: joint.dia.Point[],
    mouseEvent: MouseEvent,
    verticeIndex: number,
  ): void {
    return super.setFirstVerticalVertices(input, newVertices, mouseEvent, verticeIndex);
  }

  setLastHorizontalVertices(
    input: VerticeCalculatorInput,
    newVertices: joint.dia.Point[],
    mouseEvent: MouseEvent,
    verticeIndex: number,
  ): void {
    return super.setLastHorizontalVertices(input, newVertices, mouseEvent, verticeIndex);
  }

  setLastVerticalVertices(
    input: VerticeCalculatorInput,
    newVertices: joint.dia.Point[],
    mouseEvent: MouseEvent,
    verticeIndex: number,
  ): void {
    return super.setLastVerticalVertices(input, newVertices, mouseEvent, verticeIndex);
  }

  setMidHorizontalVertices(
    input: VerticeCalculatorInput,
    newVertices: joint.dia.Point[],
    mouseEvent: MouseEvent,
    verticeIndex: number,
  ): void {
    return super.setMidHorizontalVertices(input, newVertices, mouseEvent, verticeIndex);
  }

  setMidVerticalVertices(
    input: VerticeCalculatorInput,
    newVertices: joint.dia.Point[],
    mouseEvent: MouseEvent,
    verticeIndex: number,
  ): void {
    return super.setMidVerticalVertices(input, newVertices, mouseEvent, verticeIndex);
  }
}
